/*=========================================================================================
  File Name: router.js
  Description: Routes for vue-router. Lazy loading is enabled.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/

import Vue from "vue";
import Router from "vue-router";

Vue.use(Router);

const router = new Router({
  mode: "history",
  base: process.env.BASE_URL,
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      // =============================================================================
      // MAIN LAYOUT ROUTES
      // =============================================================================
      path: "",
      // component: () => import('./layouts/main/Main.vue'),
      component: () => import("./layouts/full-page/FullPage.vue"),
      children: [
        // =============================================================================
        // Theme Routes
        // =============================================================================
        {
          path: "/",
          name: "home",
          component: () => import("./views/pages/Error404.vue"),
        },
        {
          path: "/page2",
          name: "page-2",
          component: () => import("./views/Page2.vue"),
        },
      ],
    },
    // =============================================================================
    // FULL PAGE LAYOUTS
    // =============================================================================
    {
      path: "",
      component: () => import("@/layouts/full-page/FullPage.vue"),
      children: [
        // =============================================================================
        // PAGES
        // =============================================================================
        {
          path: "/pages/login",
          name: "page-login",
          component: () => import("@/views/pages/Login.vue"),
        },
        {
          path: "/pages/error-404",
          name: "page-error-404",
          component: () => import("@/views/pages/Error404.vue"),
        },
        {
          path: "/v1",
          name: "maylink",
          component: () =>
            import("@/views/forms/form-wizard/FieFormWizard.vue"),
        },
        {
          path: "/maylink/success",
          name: "maylink-success",
          component: () => import("@/views/pages/FieSuccess.vue"),
        },
        {
          path: "/maylink/error",
          name: "maylink-error",
          component: () => import("@/views/pages/FieError.vue"),
        },
        {
          path: "/maylink/full-tour",
          name: "maylink-full-tour",
          component: () => import("@/views/pages/FullTour.vue"),
        },
        {
          path: "/demo/1",
          name: "demo1",
          component: () =>
            import("@/views/forms/form-wizard/FormWizardValidation.vue"),
        },
      ],
    },
    // Redirect to 404 page, if no match found
    {
      path: "*",
      redirect: "/pages/error-404",
    },
  ],
});

router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById("loading-bg");
  if (appLoading) {
    appLoading.style.display = "none";
  }
});

export default router;
